<template>
    <Modal v-model="show"
        :closable="false"
        :mask-closable="false"
        :title="'请选择绑定周期 ' + year"
        width="700"
        @on-ok="onClose"
        @on-cancle="show = false">

        <Row :gutter="16">
            <Col span="3">
            <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
                <Checkbox :indeterminate="indeterminate"
                    :value="checkAll"
                    @click.prevent.native="handleCheckAll">全选</Checkbox>
            </div>
            </Col>
            <Col span="21">
            <span style="margin-right:4px;">分组:</span>
            <RadioGroup v-model="bindingName">
                <Radio label="A"></Radio>
                <Radio label="B"></Radio>
                <Radio label="C"></Radio>
                <Radio label="D"></Radio>
                <Radio label="E"></Radio>
                <Radio label="F"></Radio>
                <Radio label="G"></Radio>
                <Radio label="H"></Radio>
                <Radio label="I"></Radio>
                <Radio label="J"></Radio>
                <Radio label="K"></Radio>
                <Radio label="L"></Radio>
                <Radio label="Delete">取消绑定</Radio>
            </RadioGroup>
            </Col>

        </Row>
        <Row :gutter="16">

            <CheckboxGroup v-model="checkedWeeks"
                size="default"
                @on-change="checkAllGroupChange">
                <Col v-for="w in weekRange"
                    :key="w.value"
                    span="4">
                <Checkbox :label="w.value"
                    size="default">{{ w.label }}</Checkbox>
                </Col>
            </CheckboxGroup>

        </Row>
    </Modal>
</template>

<script>
import { getWeek } from '@/libs/logic';

export default {
    name: 'WeekBindindModal',
    data() {
        return {
            show: false,
            weekRange: [],
            checkedWeeks: [],
            indeterminate: false,
            checkAll: false,
            year: 0,
            bindingName: ''
        };
    },
    mounted() {
    },
    methods: {
        setCheckedWeeks(weeks) {
            this.checkedWeeks = weeks;
        },
        showModal(year) {
            this.year = year;
            let now = new Date();
            let curYear = now.getFullYear();
            let curWeek = getWeek();

            this.weekRange = [];
            for (let i = 1; i <= 53; i++) {
                this.weekRange.push({
                    label: `第${i}周`,
                    value: i
                });
            }

            if (year === curYear) {
                this.weekRange = this.weekRange.filter(e => {
                    return e.value >= curWeek;
                });
            }
            this.show = true;
        },
        handleCheckAll() {
            if (this.indeterminate) {
                this.checkAll = false;
            }
            else {
                this.checkAll = !this.checkAll;
            }
            this.indeterminate = false;

            if (this.checkAll) {
                this.checkedWeeks = this.weekRange.map(i => {
                    return i.value;
                });
            }
            else {
                this.checkedWeeks = [];
            }
        },
        checkAllGroupChange(data) {
            if (data.length === this.weekRange.length) {
                this.indeterminate = false;
                this.checkAll = true;
            }
            else if (data.length > 0) {
                this.indeterminate = true;
                this.checkAll = false;
            }
            else {
                this.indeterminate = false;
                this.checkAll = false;
            }
        },
        onClose() {
            this.show = false;
            this.$emit('close', this.checkedWeeks, this.bindingName);
        }
    }
};
</script>

<style scoped>
</style>
